// extracted by mini-css-extract-plugin
export default {"item":"file-list-short_item__A7ov+","link":"file-list-short_link__6Uq7L"};